import React from 'react';
import { ReactComponent as StatusBlip } from '../../../icons/status-blip.svg';

export default function StatusCell() {
  return <StatusBlip className="Status_Blip" />;
}
